import '@material/web/progress/circular-progress.js';
import './Loader.css';

export default function Loader() {
    return (
        <div className="loader-container">
            <md-circular-progress indeterminate aria-label="Caricamento in corso..."></md-circular-progress>
        </div>
    );
}
